export const DividerItem = () => {
  return <hr className="my-2 border-urbix-gray-200" />;
};
